import * as React from 'react';

const LoadMore = ({ page, maxNumPages, setPage }) => {
    if ( maxNumPages > page ) {
        const handleOnClick = () => {
            setPage( page + 1 );
        }
        
        return (
            <div className="pfa-load-more">
                <button className="pfa-load-more__button" onClick={ handleOnClick }>
                    Load More
                    <span className="pfa-load-more__plus"></span>
                </button>
            </div>
        )
    }

    return '';
}

LoadMore.displayName = 'LoadMore'

export default LoadMore;